import { Injectable, isDevMode } from '@angular/core';

/**
 * Service for getting environment.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  isDevelopment(): boolean {
    return isDevMode();
  }

  isProduction(): boolean {
    const host = window.location.hostname;
    return host === 'fms.orcainc.com';
  }

  isStaging(): boolean {
    return !this.isDevelopment() && !this.isProduction();
  }
}
